import React, { useState } from "react";
import { Alert, Button, Card } from "react-bootstrap";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import { acceptProductManagerInvitation } from "../../actions/products";

export const ProductManagementInvitation = ({
    acceptProductManagerInvitation: acceptInvitation,
    match
}) => {
    const { invitationUuid, productUuid } = match.params;
    const [state, setState] = useState({ status: "idle", message: "" });

    const accept = async () => {
        if (state.status === "saving") return;
        setState({ status: "saving", message: "" });
        const result = await acceptInvitation({
            uuid: productUuid,
            invitationUuid
        });

        if (result?.success) {
            setState({
                status: "success",
                message: "Management access accepted."
            });
            return;
        }

        setState({
            status: "error",
            message: result?.error?.message || result?.message || "The invitation could not be accepted."
        });
    };

    return (
        <div className="col-12 col-xl-8 mx-auto">
            <Card className="shadow-sm">
                <Card.Body className="p-4 p-lg-5">
                    <p className="text-primary fw-semibold mb-2">Product management invitation</p>
                    <h2 className="mb-3">Review management access</h2>
                    <p className="text-muted">
                        Accepting grants your signed-in Feradel account permission to manage this product.
                        Billing ownership and the product owner’s access do not change.
                    </p>

                    {state.status === "error" ? <Alert variant="danger" role="alert">{state.message}</Alert> : null}
                    {state.status === "success" ? (
                        <Alert variant="success" role="status">
                            {state.message} <Link to={`/dashboard/products/${productUuid}`}>Open the product</Link>.
                        </Alert>
                    ) : (
                        <div className="d-flex flex-wrap gap-2">
                            <Button type="button" onClick={accept} disabled={state.status === "saving"}>
                                {state.status === "saving" ? "Accepting…" : "Accept management access"}
                            </Button>
                            <Button as={Link} to="/dashboard" variant="outline-secondary">
                                Not now
                            </Button>
                        </div>
                    )}
                </Card.Body>
            </Card>
        </div>
    );
};

export default connect(null, { acceptProductManagerInvitation })(ProductManagementInvitation);
